export default function templatemessages(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                templatemessage: action.templatemessage,
            }
        default:
            return state;
    }
}
